export default "__VITE_PUBLIC_ASSET__81d7cdbf__"